import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table,
    Pagination,
    Checkbox,
    Tabs,
    Rate,
    Col,
    Popconfirm,
    message,
    Menu,
    Dropdown
} from 'antd';
import { Redirect, Link, withRouter } from 'react-router-dom';
import store from "../store/store.js";
import { PlusOutlined } from '@ant-design/icons'
import { PaperClipOutlined, LinkOutlined, DownOutlined, SearchOutlined, ReloadOutlined } from '@ant-design/icons'
import moment from 'moment';
import Edit from './edit.js'
import View from './view.js'
import HtView from '../hetong/view'
import { list } from 'postcss';


const { Option } = Select;
const { RangePicker } = DatePicker;
const { TabPane } = Tabs;

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            newcondition: {},
            oldcondition: {},
            list: [],
            tableloading: false,
            selectedRowKeys: [],
            count: 0,
            type: '1'
        };
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentWillMount() {
        this.props.GET_REFRESH(this.getdata)
    }

    componentDidMount() {
        // console.log(this.props)
        // let pathname = this.props.location.pathname
        this.props.NAV_CHANGE('/office', ['首页', '载体库', '办公室'])
        setTimeout(this.getdata(this.state.type, null))

    }

    onTimeChange(name, date, dateString) {
        let that = this
        console.log(name, date, dateString)
        let data = Object.assign({}, this.state.newcondition, { [name]: dateString })
        this.setState({
            newcondition: data
        })
    }

    onSelChange(name, value) {
        let that = this
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, { [name]: value })
        this.setState({
            newcondition: data
        })
    }
    onSelChange2(name, value) {
        let that = this
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition2, { [name]: value })
        this.setState({
            newcondition2: data
        })
    }

    arrsel(arr) {
        if (arr) {
            return arr.map((item, index) => <Option value={item.id} key={index}>{item.name}</Option>)
        }
    }

    onChange(name, e) {
        let that = this
        let value = e.target.value
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, { [name]: value })
        this.setState({
            newcondition: data
        })
    }

    onRangeChange(name, dates, dateStrings) {
        console.log(name, dates, dateStrings)
        var data = Object.assign({}, this.state.newcondition, {
            [name + '1']: dateStrings[0], [name + '2']: dateStrings[1]
        })
        if (data) {
            this.setState({
                newcondition: data
            })
        }
    }

    pagechange(page, pagesize) {
        let that = this
        console.log(page, pagesize)
        let data = Object.assign({}, this.state.oldcondition, { current: page, pagesize: pagesize })
        setTimeout(() => {
            this.setState({
                oldcondition: data
            })
            that.getdata(0, null)
        })
    }

    onSelectChange = selectedRowKeys => {
        console.log('selectedRowKeys changed: ', selectedRowKeys);
        this.setState({ selectedRowKeys });

        // 计算选中的 面积（亩）、面积（平米）、拟投资额
        let selected_mu = 0
        let selected_pingmi = 0
        let selected_price = 0
        const selectedItems = this.state.list.filter(item => selectedRowKeys.includes(item.id));
        selectedItems.map((item, index) => {
            if (item.mianji_unit == '平米') {
                selected_pingmi += Number(item.mianji)

            } else if (item.mianji_unit == '亩') {
                selected_mu += Number(item.mianji)
            }
            selected_price += Number(item.touzi_price)
        })
        this.setState({ selected_mu, selected_pingmi, selected_price });


    };

    onCheckboxChange(name, e) {
        let that = this
        let value = e.target.checked
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, { [name]: value })
        this.setState({
            newcondition: data
        })
    }

    getdata = (subtype = 0, e) => {
        let that = this
        that.setState({
            tableloading: true
        })
        if (subtype == 1) {
            var arr = that.state.newcondition
            let old = that.state.oldcondition
            arr = Object.assign({}, arr, { current: 1, pagesize: old.pagesize })
            that.setState({
                oldcondition: arr
            })
        } else {
            var arr = Object.assign({}, this.state.oldcondition, {})
        }
        arr.yuanqu = store.getState().data.yuanqu ? store.getState().data.yuanqu : null
        arr.type = 2
        fetch('/Zaiti/index', {
            // post提交
            method: "POST", body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 0) {
                    message.error(data.msg)
                    that.setState({
                        tableloading: false,
                    })
                    return
                }
                that.setState({
                    list: data.datalist ? data.datalist : [],
                    ...data,
                    tableloading: false,
                })
            })
    }

    delSel() {
        let that = this
        fetch('/Zaiti/allsave', {
            method: "POST", body: JSON.stringify({
                'id': this.state.selectedRowKeys,
                'type': 2
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 0) {
                    message.error(data.msg)
                    return
                }
                this.pagechange(1, this.state.oldcondition.pagesize)
                that.setState({
                    selectedRowKeys: []
                })
            })
    }

    reset() {
        let that = this
        that.setState({
            newcondition: {}, oldcondition: {},
        })
        setTimeout(() => {
            that.getdata(1, null)
        })
    }

    download(type) {
        // type==1 下载选中部分
        let that = this
        that.setState({
            downloading: true
        })
        var arr = Object.assign({}, this.state.oldcondition, {})
        if (type == 1) {
            arr = {
                id: that.state.selectedRowKeys
            }
        }
        arr.download = 1
        arr.yuanqu = store.getState().data.yuanqu ? store.getState().data.yuanqu : null
        arr.type = 2
        let filename = ''
        fetch('/Zaiti/index', {
            // post提交
            method: "POST", body: JSON.stringify(arr)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`请求失败，状态码: ${response.status}`);
                }
                filename = decodeURIComponent(response.headers.get('X-File-Name'));
                return response.blob();
            })
            .then(blob => {
                // console.log(blob)
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.target = '_blank';
                link.download = filename;
                link.click();
                window.URL.revokeObjectURL(url);
            })
            .catch(error => {
                console.error('下载文件时出错:', error);
            });
    }

    arrorder(arr, name) {
        if (arr) {
            return arr.map((item, index) =>
                <Menu.Item key={index}><a onClick={this.onOrderChange.bind(this, name, item.id)}
                    style={{ color: this.state.newcondition.order == item.id ? '#40a9ff' : '#333' }}>{item.name}</a></Menu.Item>
            )
        }
    }

    render() {
        const columns = [
            {
                title: '写字楼名称',
                dataIndex: 'name',
                key: 'name',
                // width: 200,
                fixed: 'left',
                render: (row, record) => {
                    return (<>
                        <Space>
                            <View id={record.id} title={row} refresh={this.getdata.bind(this)} />
                            {record.imgnum ? <Tag color={'blue'}>{record.imgnum}图</Tag> : null}
                        </Space>
                    </>)
                },
            }, {
                title: '地址',
                dataIndex: 'address',
                key: 'address',
                width: 200,
            }, {
                title: '租售意向',
                dataIndex: 'zsyx_text',
                key: 'zsyx_text',
                width: 130,
                render: (row, record) => {
                    return (<>
                        <Space wrap>
                            {row.map((item, index) =>
                                <Tag key={index} color={(item.id == 1 && 'blue') || (item.id == 2 && 'green')}>{item.name}</Tag>
                            )}
                        </Space>
                    </>)
                },
            },
            {
                title: '租售面积',
                dataIndex: 'zsmj',
                key: 'zsmj',
                width: 150,
            }, {
                title: <>出售价格</>,
                dataIndex: 'csjg',
                key: 'csjg',
                width: 180,
            }, {
                title: <>租赁价格</>,
                dataIndex: 'zljg',
                key: 'zljg',
                width: 180,
            }, {
                title: '物业费',
                dataIndex: 'wyf',
                key: 'wyf',
                width: 120,
            }, {
                title: '能源费',
                dataIndex: 'nyf',
                key: 'nyf',
                width: 150,
            },
            {
                title: '是否有中介费',
                dataIndex: 'sfyzjf_text',
                key: 'sfyzjf_text',
                width: 150,
            }, {
                title: '备注',
                dataIndex: 'bz',
                key: 'bz',
                width: 250,
            }, {
                title: '信息负责人',
                dataIndex: 'xxfzr',
                key: 'xxfzr',
                width: 150,
            }, {
                title: '状态',
                dataIndex: 'status_arr',
                key: 'status_arr',
                width: 150,
                fixed: 'right',
                render: (row, record) => {
                    return (<>
                        <Space wrap>
                            {record.status_arr.map((item, index) =>
                                <Tag key={index} color={((item.id == 1 || item.id == 2) && 'red') || ((item.id == 3 || item.id == 4) && 'green')}>{item.name}</Tag>
                            )}
                        </Space>
                    </>)
                },
            }, {
                title: '操作',
                dataIndex: 'cz',
                key: 'cz',
                align: 'center',
                fixed: 'right',
                width: 120,
                render: (row, record) => {
                    return (<>
                        <Space>
                            <View id={record.id} refresh={this.getdata.bind(this)} />
                            {store.getState().data.info.lmqx_bj ? (store.getState().data.info.lmqx_bj.includes('132') ?
                                <Edit refresh={this.getdata.bind(this)} id={record.id} />
                                : null) : null}
                        </Space>
                    </>)
                },
            },]
        const { tableloading, selectedRowKeys } = this.state;
        const rowSelection = {
            selectedRowKeys, onChange: this.onSelectChange.bind(this), // hideSelectAll: true,
            preserveSelectedRowKeys: false,
        };
        const hasSelected = selectedRowKeys.length > 0;
        return (<>
            <Row justify="space-between" wrap={false} align="top" gutter={[8, 8]} style={{ marginBottom: 15 }}>
                <Space wrap>
                    <Input className="input" placeholder="写字楼名称"
                        style={{ width: 200 }}
                        value={this.state.newcondition.keywords ? this.state.newcondition.keywords : null}
                        onChange={this.onChange.bind(this, 'keywords')} autoComplete="off" />
                    <Input className="input" placeholder="地址"
                        style={{ width: 200 }}
                        value={this.state.newcondition.address ? this.state.newcondition.address : null}
                        onChange={this.onChange.bind(this, 'address')} autoComplete="off" />
                    <Select placeholder="状态"
                        style={{ width: 150 }}
                        value={this.state.newcondition.status ? this.state.newcondition.status : []}
                        onChange={this.onSelChange.bind(this, 'status')} allowClear>
                        {this.arrsel(this.state.status_react)}
                    </Select>
                    <Space size={5}>
                        <Input className="input" placeholder="租售面积"
                            value={this.state.newcondition.area1 ? this.state.newcondition.area1 : null}
                            onChange={this.onChange.bind(this, 'area1')} autoComplete="off" />
                        <span>~</span>
                        <Input className="input" placeholder="租售面积"
                            value={this.state.newcondition.area2 ? this.state.newcondition.area2 : null}
                            onChange={this.onChange.bind(this, 'area2')} autoComplete="off" suffix="㎡" />
                    </Space>
                    <Space size={5}>
                        <Input className="input" placeholder="出售价格"
                            value={this.state.newcondition.csjg1 ? this.state.newcondition.csjg1 : null}
                            onChange={this.onChange.bind(this, 'csjg1')} autoComplete="off" />
                        <span>~</span>
                        <Input className="input" placeholder="出售价格"
                            value={this.state.newcondition.csjg2 ? this.state.newcondition.csjg2 : null}
                            onChange={this.onChange.bind(this, 'csjg2')} autoComplete="off" suffix="万元" />
                    </Space>
                    <Space size={5}>
                        <Input className="input" placeholder="租赁价格"
                            value={this.state.newcondition.zljg1 ? this.state.newcondition.zljg1 : null}
                            onChange={this.onChange.bind(this, 'zljg1')} autoComplete="off" />
                        <span>~</span>
                        <Input className="input" placeholder="租赁价格"
                            value={this.state.newcondition.zljg2 ? this.state.newcondition.zljg2 : null}
                            onChange={this.onChange.bind(this, 'zljg2')} autoComplete="off" suffix="元/月/平米" />
                    </Space>
                    <Button type="primary" icon={<SearchOutlined />}
                        onClick={this.getdata.bind(this, 1)}>查询</Button>
                    <Button type="primary" icon={<ReloadOutlined />} className='huise'
                        onClick={this.reset.bind(this)}>重置</Button>
                </Space>
                {store.getState().data.info.lmqx_tj ? (store.getState().data.info.lmqx_tj.includes('132') ?
                    <Edit refresh={this.getdata.bind(this)} />
                    : null) : null}
            </Row>
            <Table
                bordered
                columns={columns}
                dataSource={this.state.list}
                pagination={false}
                loading={tableloading}
                rowSelection={rowSelection}
                className='table'
                scroll={{ x: 2300 }}
                style={{ marginBottom: 20 }}
                onChange={(pagination, filters, sorter) => {
                    // console.log(pagination, filters, sorter);
                    let that = this
                    let data = Object.assign({}, this.state.newcondition, { order_by: sorter.columnKey, order_type: sorter.order })
                    this.setState({
                        newcondition: data
                    })
                    setTimeout(() => {
                        that.getdata(1)
                    })
                }}
            />
            <Row justify={'space-between'}>
                <div className='l'>
                    <Space wrap >
                        {hasSelected ? <>
                            {store.getState().data.info.lmqx_sc ? (store.getState().data.info.lmqx_sc.includes('132') ?
                                <Popconfirm
                                    title="确认删除?"
                                    onConfirm={() => this.delSel()}
                                    okText="确认"
                                    cancelText="取消"
                                >
                                    <Button type="primary" danger>删除</Button>
                                </Popconfirm>
                                : null) : null}
                            {store.getState().data.info.lmqx_dc ? (store.getState().data.info.lmqx_dc.includes('132') ?
                                <Button type="primary"
                                    onClick={() => this.download(1)}>导出</Button> : null) : null}
                        </> : null}
                        {store.getState().data.info.lmqx_dc ? (store.getState().data.info.lmqx_dc.includes('132') ?
                            <Button type="primary" onClick={() => this.download()}>全部导出</Button>
                            : null) : null}
                    </Space>
                </div>
                <Pagination showQuickJumper
                    current={this.state.oldcondition.current ? this.state.oldcondition.current : 1}
                    pageSize={this.state.oldcondition.pagesize ? this.state.oldcondition.pagesize : 10}
                    total={this.state.count} onChange={this.pagechange.bind(this)} showSizeChanger={true}
                    showTotal={total => `共 ${total} 条数据`} />
            </Row>
        </>)
    }
}

export default (props) => <Index {...props} key={props.location.pathname} />
